import * as React from 'react';

export interface IAnsweredQuestion {
    questionId: number,
    isAnswered: boolean,
    itemIndex: number
};

const useProgressBar = () => {

    const ERROR_SAVING_MESSAGE = "There was a problem saving your answer. Please try again.";

    const [answered, setAnswered] = React.useState([] as unknown as IAnsweredQuestion[]);
    const numberAnswered = answered.length;

    const getAnswered = (questionId: number) => {
        const answerForQuestion = answered.find(item => item.questionId === questionId);
        return answerForQuestion ? answerForQuestion.itemIndex : -1;
    };

    const getAnsweredString = (questionId: number) => {
        const numericValue = getAnswered(questionId);
        return numericValue === -1 ? "" : numericValue.toString();
    };

    const includedInArray = (array: IAnsweredQuestion[], questionId: number) => {
        return findInArray(array, questionId) > -1
    };

    const findInArray = (array: IAnsweredQuestion[], questionId: number) => {
        return array.findIndex(item => item.questionId === questionId);
    };

    const updateAnswered = (questionId: number, isAnswered: boolean, index: number) => {
        const answeredCopy = [...answered];
        const questionIdIndex = findInArray(answered, questionId);
        if (isAnswered) {
            if (questionIdIndex !== -1) {
                answeredCopy.splice(questionIdIndex, 1);
            }
            answeredCopy.push({ questionId, isAnswered, itemIndex: index });
        }
        if (!isAnswered) {
            const removeIndex = questionIdIndex;
            if (removeIndex > -1) {
                answeredCopy.splice(removeIndex, 1);
            }
        }
        setAnswered(answeredCopy);
    };

    const updateAllAnswered = (answers: IAnsweredQuestion[]) => {
        const answeredCopy = [...answered];
        answers.forEach(answer => {
            const questionIdIndex = findInArray(answered, answer.questionId);
            if (answer.isAnswered) {
                if (questionIdIndex !== -1) {
                    answeredCopy.splice(questionIdIndex, 1);
                }
                answeredCopy.push({ questionId: answer.questionId, isAnswered: answer.isAnswered, itemIndex: answer.itemIndex });
            }
            if (!answer.isAnswered) {
                const removeIndex = questionIdIndex;
                if (removeIndex > -1) {
                    answeredCopy.splice(removeIndex, 1);
                }
            }
        });
        setAnswered(answeredCopy);
    };

    return { numberAnswered, updateAnswered, answered, getAnswered, getAnsweredString, includedInArray, updateAllAnswered, ERROR_SAVING_MESSAGE };
};

export default useProgressBar;



// WEBPACK FOOTER //
// ./src/CustomHooks/useProgressBar.ts